// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n6iPbYlePduLLp {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  margin: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: var(--ds-space-150, 10px) var(--ds-space-100, 8px) var(--ds-space-150, 10px) 38px;
  color: var(--ds-text-inverse, #ffffff);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-weight: var(--ds-font-weight-regular, 400);
}
@media print {
  .n6iPbYlePduLLp {
    display: none;
  }
}
._SLYszuayqTyNT {
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.gff5HSNNtyyo7d {
  border-radius: var(--ds-border-radius-100, 3px);
}
.qt6KPZr99_2wuE {
  padding: var(--ds-space-100, 7px) var(--ds-space-200, 15px);
}
.DuNHrz_weUJ4R_ {
  z-index: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  padding: var(--ds-space-0, 0);
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
.DuNHrz_weUJ4R_.GvKGR2G_mQTy9j {
  align-self: flex-start;
}
.ITTe6eocqkkh9x {
  flex-grow: 1;
  padding-right: var(--ds-space-300, 25px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
.ITTe6eocqkkh9x a {
  color: var(--ds-link, #0c66e4);
}
.ITTe6eocqkkh9x.QHrG5Bo587VXBs,
.ITTe6eocqkkh9x.QHrG5Bo587VXBs a {
  color: var(--ds-text-inverse, #ffffff);
}
.tqTmW9fIJwkBM_ {
  width: 32px;
  height: 32px;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-300, 24px);
  font-size: 24px;
  line-height: 32px;
  vertical-align: middle;
}
`, ""]);
// Exports
export var bannerContainer = `n6iPbYlePduLLp`;
export var bannerShadow = `_SLYszuayqTyNT`;
export var roundedCorners = `gff5HSNNtyyo7d`;
export var inlinePadding = `qt6KPZr99_2wuE`;
export var actionButton = `DuNHrz_weUJ4R_`;
export var alignTop = `GvKGR2G_mQTy9j`;
export var textContent = `ITTe6eocqkkh9x`;
export var lightText = `QHrG5Bo587VXBs`;
export var help = `tqTmW9fIJwkBM_`;
export default ___CSS_LOADER_EXPORT___;
